import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  BppChannelStoreModelEnum,
  BppProviderStoreModel,
  BppPurchaseFormStoreModel,
  BppSubmissionStatusStoreModelEnum,
  BppSubmissionStoreModel,
  BppSummaryStoreModel,
  PebReportStoreModel,
} from '@domain/backup-power-purchase';

import {
  BppGetPebReportsStoreModel,
  BppGetPurchaseFormStoreModel,
  BppGetSubmissionsStoreModel,
  BppSubmitPurchaseFormStoreModel,
} from './models';

export const BppActions = createActionGroup({
  source: 'BACKUP-POWER-PURCHASE',
  events: {
    'Get bpp providers': emptyProps(),
    'Get bpp providers success': props<{ providers: BppProviderStoreModel[] }>(),
    'Get bpp providers fail': props<{ errorMsg: string }>(),
    'Bpp providers cache found': emptyProps(),

    'Get bpp submissions': props<{ action: BppGetSubmissionsStoreModel }>(),
    'Get bpp submissions success': props<{ submissions: BppSubmissionStoreModel[] }>(),
    'Get bpp submissions fail': props<{ errorMsg: string }>(),
    'Get bpp submissions incorrect request': emptyProps(),
    'No get bpp submissions action found': emptyProps(),

    'Get peb reports': props<{ action: BppGetPebReportsStoreModel }>(),
    'Get peb reports success': props<{ pebReports: PebReportStoreModel[] }>(),
    'Get peb reports fail': props<{ errorMsg: string }>(),

    'Get bpp summary': props<{ submissionIds: string[] }>(),
    'Get bpp summary success': props<{ summary: BppSummaryStoreModel }>(),
    'Get bpp summary fail': props<{ errorMsg: string }>(),

    'Get bpp purchase form for Fr market': props<{ requestData: BppGetPurchaseFormStoreModel; isPolling: boolean }>(),
    'Get bpp purchase form for Fr market success': props<{ purchaseForm: BppPurchaseFormStoreModel; connectToCrisis?: boolean }>(),
    'Get bpp purchase form for Fr market fail': props<{ errorMsg: string }>(),

    'Get bpp purchase form for Gb market': props<{ requestData: BppGetPurchaseFormStoreModel; isPolling: boolean }>(),
    'Get bpp purchase form for Gb market success': props<{ purchaseForm: BppPurchaseFormStoreModel; connectToCrisis?: boolean }>(),
    'Get bpp purchase form for Gb market fail': props<{ errorMsg: string }>(),

    'Refresh bpp purchase form': emptyProps(),
    'No previous bpp purchase form request found': emptyProps(),

    'Submit bpp purchase form for Fr market': props<{ requestData: BppSubmitPurchaseFormStoreModel }>(),
    'Submit bpp purchase form for Fr market success': props<{ connectedToCrisis?: boolean }>(),
    'Submit bpp purchase form for Fr market fail': props<{ errorCode: string; errorMsg: string }>(),

    'Submit bpp purchase form for Gb market': props<{ requestData: BppSubmitPurchaseFormStoreModel }>(),
    'Submit bpp purchase form for Gb market success': props<{ connectedToCrisis?: boolean }>(),
    'Submit bpp purchase form for Gb market fail': props<{ errorCode: string; errorMsg: string }>(),

    'Resubmit bpp submission': props<{ id: string; channel: BppChannelStoreModelEnum }>(),
    'Resubmit bpp submission success': emptyProps(),
    'Resubmit bpp submission fail': props<{ errorCode: string; errorMsg: string }>(),

    'Resubmit bpp submission batch': props<{ submissions: { id: string; channel: BppChannelStoreModelEnum }[] }>(),
    'Resubmit bpp submission batch response': props<{ success: number; fail: number }>(),

    'Set bpp submission status': props<{ id: string; status: BppSubmissionStatusStoreModelEnum }>(),
    'Set bpp submission status success': emptyProps(),
    'Set bpp submission status fail': props<{ errorCode: string; errorMsg: string }>(),

    'Clear peb reports': emptyProps(),
    'Clear bpp submissions': emptyProps(),
    'Clear bpp providers': emptyProps(),
    'Clear bpp summary': emptyProps(),
    'Clear bpp purchase form': emptyProps(),
  },
});
